import { useQuery, gql } from '@apollo/client'
import { format } from 'date-fns'
import { DATETIME } from 'constants/datetime'

const EXPERT_CONSULTATIONS_QUERY = gql`
  query expertConsultationsQuery(
    $id: Int!
    $expertChartsInput: ExpertChartOptions!
  ) {
    expertMe(id: $id) {
      id
      charts {
        sessionCount(input: $expertChartsInput) {
          date {
            isoFormat
          }
          unix
          chartData {
            status
            value
            currencyIsoCode
          }
        }
      }
    }
  }
`

export const useExpertConsultationsQuery = ({
  expertId: id,
  period: { date, groupBy: groupType } = {},
}) => {
  const { loading: isLoading, data: sessionCount } = useQuery(
    EXPERT_CONSULTATIONS_QUERY,
    {
      variables: {
        id,
        expertChartsInput: {
          date: {
            from: format(date.from, DATETIME),
            to: format(date.to, DATETIME),
          },
          groupType,
        },
      },
    }
  )

  const data = sessionCount ? sessionCount.expertMe.charts.sessionCount : []

  return { isLoading, data }
}
